export default "__VITE_ASSET__BagiosvK__"